// ISSUE-1057 R3 and R6. The staged PDF in the composer: name, upload state, inline error, Retry, Remove.
import type { ReactNode } from "react";

import {
  COMPOSER_PDF_UPLOADING_LABEL,
  COMPOSER_PHOTO_RETRY_LABEL,
  COMPOSER_REMOVE_PDF_LABEL,
} from "./chatExtrasCopy";
import { formatFileSize } from "./fileSizeFormat";
import type { typeComposerPdfAttachment } from "./useComposerPdfUpload";

export type typeComposerPdfChipProps = {
  attachment: typeComposerPdfAttachment;
  onRetry: () => void;
  onRemove: () => void;
};

export const ComposerPdfChip = (props: typeComposerPdfChipProps): ReactNode => {
  const { attachment } = props;
  return (
    <div
      data-testid="composer-pdf-attachment"
      className="flex items-center gap-3 rounded-md border border-hairline px-3 py-2"
    >
      <span
        aria-hidden="true"
        className="grid size-10 shrink-0 place-items-center rounded-md bg-surface-secondary text-body-strong text-ink"
      >
        PDF
      </span>
      <div className="flex min-w-0 flex-1 flex-col">
        <span
          data-testid="composer-pdf-attachment-name"
          className="truncate text-body text-ink"
        >
          {attachment.file.name}
        </span>
        {attachment.state === "uploading" ? (
          <span
            data-testid="composer-pdf-attachment-uploading"
            className="text-caption text-ink-tertiary"
          >
            {COMPOSER_PDF_UPLOADING_LABEL}
          </span>
        ) : null}
        {attachment.state === "ready" ? (
          <span
            data-testid="composer-pdf-attachment-size"
            className="text-caption text-ink-tertiary"
          >
            {formatFileSize(attachment.file.size)}
          </span>
        ) : null}
        {attachment.state === "failed" ? (
          <p
            role="alert"
            data-testid="composer-pdf-attachment-error"
            className="text-caption text-error"
          >
            {attachment.failure?.message}
          </p>
        ) : null}
      </div>
      {attachment.state === "failed" &&
      attachment.failure?.canRetry === true ? (
        <button
          type="button"
          data-testid="composer-pdf-attachment-retry"
          onClick={props.onRetry}
          className="min-h-touch-target px-2 text-caption text-primary underline"
        >
          {COMPOSER_PHOTO_RETRY_LABEL}
        </button>
      ) : null}
      <button
        type="button"
        aria-label={COMPOSER_REMOVE_PDF_LABEL}
        data-testid="composer-pdf-attachment-remove"
        onClick={props.onRemove}
        className="flex min-h-touch-target min-w-touch-target items-center justify-center text-body text-ink-secondary"
      >
        ✕
      </button>
    </div>
  );
};
